import React from "react";
import {withErrorBoundary} from "../../../components/ErrorBoundary";
import {useTranslation} from "react-i18next";
import CheckForm from "../CheckForm";
import AuthorizedError404 from "../../error/AuthorizedError404";
import useCheckForm from "../hooks/useCheckForm";

const CheckEdit = () => {
  const {
    formConfig,
    formConfig: {isProjectAdmin},
    form,
    Prompt
  } = useCheckForm();
  const {t} = useTranslation();

  if (!isProjectAdmin) {
    return <AuthorizedError404/>;
  }

  return (
    <CheckForm
      header={t("card.title.check.edit", "Edit check")}
      {...formConfig}
      {...form}
      Prompt={Prompt}
    />
  );
};

export default withErrorBoundary(CheckEdit);